import type {
  DashboardPayload,
  FlushQueueResult,
  FulfillmentRunResult,
  MaintenanceState,
  PennylaneRunResult,
} from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/** `GET /api/dashboard` (`02` §2) : un seul payload agrégé, pas de filtre. */
export function fetchDashboardPayload(period?: { from: string; to: string }): Promise<DashboardPayload> {
  const query = period ? `?from=${encodeURIComponent(period.from)}&to=${encodeURIComponent(period.to)}` : '';
  return apiFetch<DashboardPayload>(`/api/dashboard${query}`);
}

export function refreshDashboardHealth(): Promise<{ queued: boolean }> {
  return apiFetch('/api/dashboard/health/refresh', { method: 'POST' });
}

/**
 * Actions du tableau de bord : chacune vit sur son propre écran (`02` §6, §7,
 * §5, §12) mais est aussi déclenchable depuis le tableau de bord (`02` §2 :
 * « Lancer maintenant », « Envoyer la file », « Désactiver »). Pas de
 * duplication d'écran ici, seulement les mêmes endpoints, appelés
 * directement (cette vague ne touche que `features/dashboard/`).
 */

export function runFulfillmentNow(): Promise<FulfillmentRunResult> {
  return apiFetch<FulfillmentRunResult>('/api/fulfillment/run', { method: 'POST', body: { simulation: false } });
}

export function runPennylaneNow(): Promise<PennylaneRunResult> {
  return apiFetch<PennylaneRunResult>('/api/pennylane/run', { method: 'POST', body: { simulation: false } });
}

export function flushMaintenanceQueue(): Promise<FlushQueueResult> {
  return apiFetch<FlushQueueResult>('/api/files/flush', { method: 'POST' });
}

export function disableMaintenanceMode(): Promise<MaintenanceState> {
  return apiFetch<MaintenanceState>('/api/settings/maintenance/toggle', {
    method: 'POST',
    body: { enabled: false, flushQueue: false },
  });
}
